import './replace_asset_modal_ui.less';

import React, { Fragment } from 'react';
import isEmpty from 'lodash/isEmpty';

import Button from 'zoomforth_codesbane_editor/component_lib/button.jsx';
import { CloseIcon, ErrorIcon, CheckCircleIcon } from 'zoomforth_component_lib/app_modern_icons';
import { PlainCheckbox } from 'zoomforth_component_lib/checkbox.jsx';
import CircularSpinner from 'zoomforth_component_lib/circular_spinner.jsx';
import SiteList from './site_list';

const SiteListView = (props) => {
  const {
    selected,
    siteList,
    hasSelectedAll,
    onClose,
    onToggleSelectSite,
    onToggleSelectAll,
    onReplace
  } = props;

  return (
    <Fragment>
      <span className="close-button" onClick={onClose}><CloseIcon /></span>
      <div className="header">
        <h2>Select sites to update</h2>
        <p>There are {siteList.length} sites using the selected file. Changes will be published automatically, but you will need to check cropping settings on each site.</p>
      </div>
      <div className="body">
        <div className="select-all">
          <PlainCheckbox
            id="select-all"
            checked={hasSelectedAll}
            onChange={onToggleSelectAll}
          />
          <label htmlFor="select-all" >
            Select all sites
          </label>
        </div>
        <SiteList sites={siteList} selected={selected} shouldShowCheckbox={true} onToggleSelectSite={onToggleSelectSite} />
      </div>
      <div className="actions">
        <a className="cancel-button" href="#" onClick={onClose}>Cancel</a>
        <div className="warning-text">
          <p>This cannot be reverted</p>
          <ErrorIcon />
        </div>
        <div className="action-button">
          <Button className="update-button" disabled={isEmpty(selected)} onClick={onReplace}>Update Selected</Button>
        </div>
      </div>
    </Fragment>
  );
};

const ReplaceView = (props) => {
  const { selectedSites, isReplaceSuccess, onClose } = props;

  return (
    <Fragment>
      {isReplaceSuccess ?
        <div className="header success">
          <h2>{selectedSites.length} sites updated</h2>
          <p>Your changes are now live in these sites. Click on each site name to check and adjust cropping settings.</p>
        </div>
        :
        <div className="header">
          <h2>Updating the following {selectedSites.length} sites</h2>
          <p>Your changes will immediatly go live to the selected sites. Cropping settings will have to be checked individually.</p>
        </div>
      }

      <div className="body">
        <SiteList sites={selectedSites} />
      </div>
      <div className="actions replace-view">
        <div className="cancel-button"></div>
        <div className="warning-text"></div>
        <div className="action-button">
          {isReplaceSuccess ?
            <Button className="done-button" onClick={onClose}>
              <CheckCircleIcon />
              Done
            </Button>
            :
            <div className="loading-indicator">
              <CircularSpinner width={10} height={10} />
              <div>Replacing</div>
            </div>
          }
        </div>
      </div>
    </Fragment>
  );
};

const ReplaceAssetModalUI = (props) => {
  return (
    props.currentView == 'replace' ?
      <ReplaceView {...props} />
      :
      <SiteListView {...props} />
  );
};

export default ReplaceAssetModalUI;
